export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#1a2b4a] via-[#2a3b5a] to-[#1a2b4a]">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/bad6109261ea26fb9c373b1a35fd8bdc.jpeg"
          alt="船橋市密着のリフォームチーム"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 py-16 sm:py-20 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/95 backdrop-blur-sm px-4 sm:px-6 py-2 sm:py-3 rounded-full mb-6 sm:mb-8 shadow-xl">
          <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
            <i className="ri-map-pin-fill text-[#ff8c42] text-base sm:text-lg"></i>
          </div>
          <span className="text-[#1a2b4a] font-bold text-sm sm:text-base">船橋市密着の水回りリフォーム専門店</span>
        </div>

        {/* Main Copy */}
        <h1 
          className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white leading-tight px-2 mb-4 sm:mb-6"
        >
          <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">船橋市</span>
          <span className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl">で</span>
          <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">水回りリフォーム</span>
          <span className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl">に</span>
          <br />
          <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">失敗</span>
          <span className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl">したくないあなたへ</span>
        </h1>

        {/* Sub Copy */}
        <p 
          className="text-base sm:text-lg lg:text-xl text-white mb-8 sm:mb-10 leading-relaxed max-w-3xl mx-auto px-4"
        >
          <span className="block text-[10px] sm:text-base">
            水回り専門の技術に、ホスピタリティを。<br />
            「七つの約束」が守る、価格を超えた頼んで良かったを。
          </span>
        </p>

        {/* Trust Badges - Enhanced */}
        <div className="flex flex-nowrap justify-center gap-3 sm:gap-6 mb-8 sm:mb-12 px-2">
          <div className="bg-gradient-to-br from-white via-white to-gray-50 w-[30%] sm:w-auto sm:px-8 py-4 sm:py-5 rounded-2xl shadow-2xl flex-shrink-0 border-2 border-[#ff8c42]/20">
            <div className="flex flex-col items-center gap-1 sm:gap-2">
              <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-gradient-to-br from-[#ff8c42] to-[#ff7a2e] rounded-full shadow-lg mb-1">
                <i className="ri-team-fill text-white text-base sm:text-xl"></i>
              </div>
              <div className="text-center">
                <div className="text-[#ff8c42] font-bold text-lg sm:text-3xl leading-none mb-1">6,812件</div>
                <div className="text-[#1a2b4a] font-medium text-[8px] sm:text-xs">累計水回り施工実績</div>
              </div>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-white via-white to-gray-50 w-[30%] sm:w-auto sm:px-8 py-4 sm:py-5 rounded-2xl shadow-2xl flex-shrink-0 border-2 border-[#ff8c42]/20">
            <div className="flex flex-col items-center gap-1 sm:gap-2">
              <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-gradient-to-br from-[#ff8c42] to-[#ff7a2e] rounded-full shadow-lg mb-1">
                <i className="ri-star-fill text-white text-base sm:text-xl"></i>
              </div>
              <div className="text-center">
                <div className="text-[#ff8c42] font-bold text-lg sm:text-3xl leading-none mb-1">★4.7</div>
                <div className="text-[#1a2b4a] font-medium text-[8px] sm:text-xs">Google口コミ評価</div>
              </div>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-white via-white to-gray-50 w-[30%] sm:w-auto sm:px-8 py-4 sm:py-5 rounded-2xl shadow-2xl flex-shrink-0 border-2 border-[#ff8c42]/20">
            <div className="flex flex-col items-center gap-1 sm:gap-2">
              <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-gradient-to-br from-[#ff8c42] to-[#ff7a2e] rounded-full shadow-lg mb-1">
                <i className="ri-home-heart-fill text-white text-base sm:text-xl"></i>
              </div>
              <div className="text-center">
                <div className="text-[#ff8c42] font-bold text-sm sm:text-2xl leading-none mb-1">船橋市</div>
                <div className="text-[#1a2b4a] font-medium text-[8px] sm:text-xs">地域密着専門店</div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col gap-3 sm:gap-4 justify-center px-4">
          <a 
            href="tel:047-401-0700"
            className="flex items-center justify-center gap-2 sm:gap-3 bg-[#ff8c42] text-white px-8 sm:px-12 py-4 sm:py-6 rounded-full text-base sm:text-lg font-bold hover:bg-[#ff7a2e] transition-all shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center bg-white/20 rounded-full">
              <i className="ri-phone-fill text-lg sm:text-xl"></i>
            </div>
            今すぐ電話で相談
          </a>
          
          <a 
            href="https://lin.ee/0Rgwq5v1"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 sm:gap-3 bg-white text-[#1a2b4a] px-8 sm:px-12 py-4 sm:py-6 rounded-full text-base sm:text-lg font-bold hover:bg-gray-100 transition-all shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
              <i className="ri-line-fill text-lg sm:text-xl"></i>
            </div>
            LINEで気軽に相談
          </a>
        </div>

        {/* Trust Message */}
        <p className="text-gray-200 mt-6 sm:mt-8 text-sm sm:text-base px-4">
          無理な営業は一切いたしません。まずはお気軽にご相談ください。
        </p>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden sm:block">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}